import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ThemeProvider } from "styled-components";
import theme from "./styles/theme";
import Home from "./pages/Home";
import LandingPage from "./components/landing/LandingPage";
import GlobalToast from "./components/toast/GlobalToast";
import App from "./App";
import { UserContext, UserProvider } from "./context/UserContext";
import { HelmetProvider } from "react-helmet-async";
import { HeadProvider, Title, Meta, Link } from "react-head";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <UserProvider>
        {/* <HeadProvider> */}
        <App />
        {/* </HeadProvider> */}
      </UserProvider>
      {/* <LandingPage /> */}
    </ThemeProvider>
  </React.StrictMode>
);
